import { IMAGES, APP_SCREENSHOTS, LINKS, CONTENT } from "../../const/config";
import { AndroidIcon, AppleIcon, InfoItem, PlatformDownload, ImageCarousel } from "../../components/home/Index";
import Footer from "../../components/Footer";
import { useStoreLinks } from "../../hooks/useStoreLinks";

export default function DesktopView() {
  const { links: storeLinks } = useStoreLinks();

  const androidData = {
    directLink: LINKS.android.direct,
    storeLink: storeLinks.android,
  };

  const iosData = {
    directLink: LINKS.ios.direct,
    storeLink: storeLinks.ios,
  };

  return (
    <div className="min-h-screen bg-white flex flex-col" style={{ fontFamily: "'Montserrat', sans-serif" }}>
      {/* ── Header ── */}
      <header className="w-full text-center pt-10 pb-6 px-4">
        <h1 className="text-3xl font-bold text-blue-600 tracking-tight">
          {CONTENT.header.title}
        </h1>
        <p className="text-gray-400 text-sm mt-1.5">
          {CONTENT.header.subtitle}
        </p>
      </header>

      {/* ── Two-column content ── */}
      <main className="flex-1 w-full max-w-5xl mx-auto px-6 pb-10">
        <div className="flex flex-row gap-10 items-start">

          {/* ─── Left Column ─── */}
          <div className="w-3/5 lg:w-2/3 flex-shrink-0 flex flex-col items-start text-left">

            {/* Hero image */}
            <div className="overflow-hidden mb-6 p-4 shadow-sm rounded-lg bg-blue-600 flex justify-center items-center">
              <img
                src={IMAGES.logo}
                alt="App preview"
                className="w-auto h-24 object-contain"
              />
            </div>

            {/* Info items */}
            <div className="w-full space-y-1">
              {CONTENT.features.map((feature, i) => (
                <InfoItem key={i} value={feature.value} sub={feature.sub} />
              ))}
            </div>

            {/* Download section */}
            <div className="mt-8 w-full">
              <p className="text-xs text-gray-400 uppercase font-semibold tracking-wider mb-5">
                {CONTENT.labels.downloadApp}
              </p>
              <div className="flex gap-6 justify-start items-stretch">
                <PlatformDownload
                  icon={<AndroidIcon />}
                  title="Android"
                  {...androidData}
                />
                <div className="w-px bg-gray-200 self-stretch my-2" />
                <PlatformDownload
                  icon={<AppleIcon />}
                  title="iOS"
                  {...iosData}
                />
              </div>
            </div>
          </div>

          {/* ─── Right Column — Carousel ─── */}
          <div className="flex-1 min-w-0 flex flex-col items-center text-center">
            <p className="text-xs text-gray-400 uppercase font-semibold tracking-wider mb-4">
              {CONTENT.labels.screenshots}
            </p>
            <ImageCarousel images={APP_SCREENSHOTS} />
          </div>
        </div>
      </main>

      <Footer />
    </div>
  );
}